// extracted by mini-css-extract-plugin
export default {"coming-wrapper":"comingsoon_coming-wrapper__+UB42","coming-text":"comingsoon_coming-text__i7kt4"};